const projectRecord = (project) => (project && typeof project === 'object' && !Array.isArray(project) ? project : {});

export function resolveProjectRecordId(project, fallbackProjectId = '') {
  const source = project ?? {};
  return String(source.project_id || source.id || source.key || fallbackProjectId || '').trim();
}

export function buildProjectProjection(project, fallbackProjectId, fallbackName) {
  const source = projectRecord(project);
  const projectId = resolveProjectRecordId(source, fallbackProjectId);
  return {
    ...source,
    key: String(source.key || projectId).trim() || projectId,
    project_id: projectId,
    name: String(source.name || source.project_name || fallbackName || '').trim(),
    status: String(source.status || 'active').trim() || 'active',
  };
}

export function mergeProjectProjection(projectItems, project) {
  const projectId = resolveProjectRecordId(project);
  const source = Array.isArray(projectItems) ? projectItems : [];
  if (!projectId) {
    return source;
  }
  let found = false;
  const nextItems = source.map((item) => {
    if (resolveProjectRecordId(item) !== projectId) {
      return item;
    }
    found = true;
    return { ...item, ...project };
  });
  return found ? nextItems : [project, ...source];
}
